import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useI18n } from "../lib/i18n";
import { BrandMark } from "./BrandMark";
import { IconEsim, IconExplore, IconUser } from "./Icons";

export function Shell() {
  const { user, loading, error, login } = useAuth();
  const { t } = useI18n();

  if (loading) {
    return (
      <div className="app-shell" style={{ justifyContent: "center", alignItems: "center" }}>
        <div className="spinner" />
        <p className="muted" style={{ marginTop: 14 }}>
          {t("connecting")}
        </p>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="app-shell">
        <div className="topbar">
          <div className="brand">
            <BrandMark />
            <span>EGoeSIM</span>
          </div>
        </div>
        <img className="hero-ill" src="/ill/ill_login.svg" alt="" />
        {error && <div className="error-box">{error}</div>}
        <div className="card">
          <h2 className="card-title">{t("secureLogin")}</h2>
          <p className="muted" style={{ margin: "0 0 12px" }}>
            {t("loginHint")}
          </p>
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => {
              void login();
            }}
          >
            {t("continueLogin")}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="app-shell">
      <div className="topbar">
        <div className="brand">
          <BrandMark />
          <div>
            <div>EGoeSIM</div>
            <div className="muted" style={{ fontSize: 11, fontWeight: 500 }}>
              {user.email}
            </div>
          </div>
        </div>
      </div>
      <Outlet />
      <nav className="tabs" aria-label="main">
        <div className="tabs-inner">
          <NavLink to="/" end className={({ isActive }) => `tab${isActive ? " active" : ""}`}>
            <IconExplore className="tab-icon" />
            {t("tabExplore")}
          </NavLink>
          <NavLink to="/esims" className={({ isActive }) => `tab${isActive ? " active" : ""}`}>
            <IconEsim className="tab-icon" />
            {t("tabEsim")}
          </NavLink>
          <NavLink to="/account" className={({ isActive }) => `tab${isActive ? " active" : ""}`}>
            <IconUser className="tab-icon" />
            {t("tabAccount")}
          </NavLink>
        </div>
      </nav>
    </div>
  );
}
